import { connect } from 'react-redux';
import { saveSong, downloadSong, loadSong, newSong } from '../actions/song';
import Toolbar from '../components/Toolbar';
import { toggleUIState } from '../actions/ui';

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  song: state.song,
  songlist: state.songlist,
  ui: state.ui,
  style: ownProps.style,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSave: (event) => {
    if (event) event.preventDefault();
    dispatch(saveSong());
  },
  onDownload: (event) => {
    if (event) event.preventDefault();
    dispatch(downloadSong());
  },
  onLoad: (filename) => {
    dispatch(loadSong(filename));
  },
  onNewSong: (event) => {
    if (event) event.preventDefault();
    dispatch(newSong());
    ownProps.history.push('/');
  },
  onChangeField: (field, value) => {
    // dispatch(changeSongField(field, value));
  },
  onToggleUI: (name) => {
    dispatch(toggleUIState(name));
  },
});

const ToolbarContainer = connect(mapStateToProps, mapDispatchToProps)(Toolbar);

export default ToolbarContainer;



// WEBPACK FOOTER //
// ./src/containers/ToolbarContainer.js